import React from 'react'

const WorkspaceMetadataConformityCheckStudiesPanel = () => {
  return <div>WorkspaceMetadataConformityCheckStudiesPanel</div>
}

export default WorkspaceMetadataConformityCheckStudiesPanel
